import { render } from "./EditVirement.vue?vue&type=template&id=79b17caf&ts=true"
import script from "./EditVirement.vue?vue&type=script&lang=ts"
export * from "./EditVirement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__